import { Component, inject, OnInit, input } from '@angular/core';
import { ButtonV3Component, ColumnRendererComponentV3, IconV3Component, TableServiceV3 } from '@gea/digital-ui-lib';
import { Annunciation } from '@shared/models';
import { TranslatePipe } from '@ngx-translate/core';
import { Fix_ACTION } from '@fault-analysis/table-config/fault-analysis-column-definitions';

import { ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'gea-hrt-link-button-renderer',
  imports: [TranslatePipe, IconV3Component, ButtonV3Component],
  template: `
    @if (showButton) {
      <div>
        <geaui-button-v3 type="secondary" (click)="onClick()">
          <geaui-icon-v3 file="wrench" [fileSize]="16" class="fix_key" />
          <span>
            {{ 'FAULT_ANALYSIS.FIX_BUTTON' | translate }}
          </span>
        </geaui-button-v3>
      </div>
    }
  `,
  styles: `
    ::ng-deep .p-button {
      height: unset !important;
    }
    ::ng-deep span.p-button-content {
      display: flex !important;
      align-items: center;
      justify-content: center;
      gap: 2px;
    }
  `,
})
export class LinkButtonRendererComponent implements OnInit, ColumnRendererComponentV3<Annunciation> {
  tableService = inject(TableServiceV3);

  readonly rowData = input<Annunciation>();

  tableId?: string;
  showButton = false;

  ngOnInit(): void {
    const rowData = this.rowData();
    if (rowData && rowData.countPending > 0) {
      this.showButton = true;
    }
  }

  onClick() {
    if (!this.tableId) return;
    this.tableService.publishAction(this.tableId, Fix_ACTION, this.rowData());
  }
}
